import React from 'react';
import { Spin } from 'antd';

import { compose, removeItem } from '../../core';
import ROUTE from '../route';
import USER_ROUTE from '../../user/route';
import { getIntFromString } from '../../look';

import QuizView from '../components/QuizView';
import { withCreateResponse, withPublicSurveyById, withOrgSurveyById } from './SurveyOperations';

// Function to deduplicate answers, keeping only the latest answer for repeated questionIds
function deduplicateAnswers(answers) {
  // First identify which questionIds have duplicates
  const questionIdCounts = answers.reduce((acc, curr) => {
    acc[curr.questionId] = (acc[curr.questionId] || 0) + 1;
    return acc;
  }, {});

  // For questionIds that appear more than once, keep only the latest answer
  const seenDuplicates = new Set();
  return answers.reverse().filter(answer => {
    if (questionIdCounts[answer.questionId] === 1) {
      // Not a duplicate, keep it
      return true;
    }
    
    if (!seenDuplicates.has(answer.questionId)) {
      // First occurrence of a duplicate (the latest one since we reversed)
      seenDuplicates.add(answer.questionId);
      return true;
    }
    
    // Skip older duplicates
    return false;
  }).reverse(); // Restore original order
}

const SurveyQuiz = props => {
  const { error, history, createResponse, orgSurveyById, publicSurveyById } = props;
  const startTime = new Date().getTime();
  const [prevTotalDuration, setPrevTotalDuration] = React.useState(0);
  const [submitLoading, setSubmitLoading] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);
  if (error) {
    if (error.message === 'GraphQL error: Permission Denied.') {
      // setRedirect(true);
      setTimeout(3000, history.push(USER_ROUTE.login));
    }
  }

  const handleSubmit = async answers => {
    setSubmitLoading(true);
    const endTime = new Date().getTime();
    try {
      // Only deduplicate answers, keeping only latest answers for repeated questionIds
      const deduplicatedAnswers = deduplicateAnswers(answers);
      
      console.log('SURVEY_DEBUG: Original answers count:', answers.length);
      console.log('SURVEY_DEBUG: Deduplicated answers count:', deduplicatedAnswers.length);
      
      const response = await createResponse({
        answers: deduplicatedAnswers,
        surveyId:
          (orgSurveyById && getIntFromString(orgSurveyById.id)) ||
          (publicSurveyById && getIntFromString(publicSurveyById.id)),
        totalDuration: prevTotalDuration + (endTime - startTime) / 1000 // returns time in seconds
      });
      response && setSubmitted(true);
      response && removeItem(orgSurveyById ? orgSurveyById.id : publicSurveyById.id);
      if (response) history.push(`${ROUTE.surveyResponseLink}${getIntFromString(response.id)}`);
    } catch (e) {
      throw new Error(e.message);
    }
    setSubmitLoading(false);
  };

  return (
    <Spin spinning={submitLoading} size="large">
      <QuizView
        submitted={submitted}
        onSubmit={handleSubmit}
        setPrevTotalDuration={setPrevTotalDuration}
        quizStartTime={startTime}
        {...props}
      />
    </Spin>
  );
};

export default compose(withCreateResponse, withPublicSurveyById, withOrgSurveyById)(SurveyQuiz);
